import { cn } from "cn";

/**
 * The tile's Remove and "…" buttons sit on a picture, and the outline button's hover
 * tint (`bg-bg-dark-min`) is translucent — so the picture showed through on hover. An
 * opaque surface is laid underneath as an `after` pseudo-element instead.
 *
 * `isolate` keeps the `-z-10` layer inside the button rather than under the picture. In
 * its own stacking context, though, that layer paints ABOVE the button's background and
 * border, so it draws them itself: the same 1px border, and on hover — or while its
 * menu is open — the same tint as a background image over the opaque color.
 */
export const OVERLAY_BUTTON_CLASS_NAME = cn(
  /* sorted */
  "isolate",
  "rounded-full",
  "after:absolute after:-inset-px after:-z-10 after:rounded-full after:border after:border-border-dark-low after:bg-bg-surface-elevate-low hover:after:bg-[image:linear-gradient(var(--color-bg-dark-min),var(--color-bg-dark-min))] aria-expanded:after:bg-[image:linear-gradient(var(--color-bg-dark-min),var(--color-bg-dark-min))]",
);
